import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { UnloadingOutput, UnloadingPass, UnloadingService } from 'core/http/project';
import { Dictionary } from 'lodash';
import { Observable } from 'rxjs';

@Injectable()
export class UnloadingResolver {
  constructor(private unloadingService: UnloadingService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<UnloadingOutput> {
    return this.unloadingService.getUnloading(route.params.unloadingId);
  }
}

@Injectable()
export class UnloadingPassResolver {
  constructor(private unloadingService: UnloadingService) {
  }

  resolve(snapshot: ActivatedRouteSnapshot): Observable<UnloadingPass> {
    return this.unloadingService.getUnloadingPass(snapshot.parent!.params.unloadingId, snapshot.params.passId);
  }
}

@Injectable()
export class RejectedOrdersCountByOrderCountResolver {
  constructor(private unloadingService: UnloadingService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<Dictionary<number>> {
    const unloadingId = route.params.unloadingId;
    const passId = route.params.passId;

    return this.unloadingService.getRejectedOrdersCountByErrorType(unloadingId, passId);
  }
}
